<script>

    import GitHub from './components/github.svelte'

    import Project from './project/project.svelte'
    import TopAppBar, {
        Row,
        Section,
        Title,
        AutoAdjust,
    } from '@smui/top-app-bar';
    import {loadSettings} from './lib/local-storage';
    import Snackbar, { Actions, Label } from '@smui/snackbar';
    import { onMount } from 'svelte';
    import LocationSearch from './project/location-search.svelte';
    import Dialog, { Content } from '@smui/dialog';

    import List, {
      Item,
      Graphic,
      Meta,
      Text,
      PrimaryText,
      SecondaryText,
    } from '@smui/list';

    let project;
    let topAppBar;
    let shareMsg;
    let snackBarTxt = '';
    let infoDialog = false;
    let shareData = {
      title: 'Map sense file',
      text: 'Your latest "Map sense" project.',
      url: 'https://b-lack.github.io/map-sense/',
      files: []
    }
    const toExtent = (extent) => {
      project.focusToLatLngExtent(extent);
    }
    const resetSettings = () => {
      project.resetSettings()
    }
    /*const share = async () => {
      const settings = loadSettings();
      const settingsString = JSON.stringify(settings);
      //var blob = new Blob([settingsString],{ type: "text/json;charset=utf-8" });
      const file = new File([settingsString], "map-sense.json", {type: "application/json;charset=utf-8"});
      // CREATE FILE
      if(checkSharing){
        try{
          await navigator.share({
            title: 'Map sense file',
            text: 'Your latest "Map sense" project.',
            url: 'https://b-lack.github.io/map-sense/',
            files: [file] // An array of File objects representing files to be shared.
          });
        } catch(err){
          snackBarTxt = err;
          shareMsg.open();
          console.log(err);
        }
      }else{
        alert('downloading');
      }
    }*/
    const createFile = () => {
      const settings = loadSettings();
      const settingsString = JSON.stringify(settings);
      //var blob = new Blob([settingsString],{ type: "text/json;charset=utf-8" });
      const file = new File([settingsString], "map-sense.txt", {type: "text/plain"});
      shareData.files.push(file)
    }
    onMount(async () => {
      createFile();
      const btn = document.querySelector('#share-btn');
      /*btn.addEventListener('click', async () => {
        try {
          await navigator.share(shareData)
        } catch(err) {
          snackBarTxt = err;
          shareMsg.open();
        }
      });*/
    });
    const _openInfo = () => {
      infoDialog = true;
    }
</script>

<Snackbar bind:this={shareMsg}>
  <Label>{snackBarTxt}</Label>
</Snackbar>

<TopAppBar bind:this={topAppBar} variant="standard" dense>
    <Row>
      <Section on:click={_openInfo}>
        <img class="ge-map-sense" src="./asset/map-sense-outlines.svg" alt="MAP SENSE"/>
        <Title>MAP SENSE</Title>
      </Section>
      <LocationSearch toExtent={toExtent}/>
      <!--<Section align="end" toolbar>
        <Wrapper>
          <IconButton class="material-icons" on:click={resetSettings}>restart_alt</IconButton>
          <Tooltip>Reset everything.</Tooltip>
        </Wrapper>
        <IconButton aria-label="Bookmark this page"><GitHub/></IconButton>
      </Section>-->
    </Row>
</TopAppBar>
<AutoAdjust {topAppBar}>
  <Project bind:this={project}/>
</AutoAdjust>

<!--<Wrapper>
          <IconButton id="share-btn" class="material-icons" aria-label="Download">share</IconButton>
          <Tooltip>{checkSharing() ? 'Share' : 'Download'} your setting & data.</Tooltip>
        </Wrapper>-->

<Dialog
  bind:open={infoDialog}
  aria-labelledby="simple-title"
  aria-describedby="simple-content"
>
  <!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
  <Content id="simple-content">
    <p>
      Create (syntatic) datasets for machine learning on geospacial map data.
    </p>
    <h5>
      Acknowledgments
    </h5>
    <p>
      MAP SENSE is developed openly at <a target="_blank" href="https://boku.ac.at/en/wabo/ft">Institute of Forest Engineering</a>, <a target="_blank" href="https://boku.ac.at/en/">University of Natural Rescources and Life Science</a>, Vienna, Austria.
    </p>

    <h5>
      Development
    </h5>
      <a href="https://gruenecho.de/en" target="_blank" class="cursor-pointer">
        <Item>
          <Graphic style="background-image: url(https://place-hold.it/40x40?text=rtrt&fontsize=16);"
          />
          <Text>
            <PrimaryText>Grünecho</PrimaryText>
            <SecondaryText>Forstry-Software Development and Consulting</SecondaryText>
          </Text>
        </Item>
      </a>
    
    <h5>
      Further information...
    </h5>
    <div class="ge-center">
      Source Code, Citation and License information: 
      <GitHub/>
    </div>
  </Content>
</Dialog>